import { LineChart as RechartsLineChart } from 'recharts';

export const LineChart = (
    props: React.ComponentProps<typeof RechartsLineChart>
) => {
    return (
        <RechartsLineChart data-testid={'LineChart-container'} {...props} />
    );
};

export default LineChart;
